// Separate FeedbackButton component for importing directly
import React from 'react';
import '../layout/FeedbackModal.css';

const FeedbackButton = ({ onClick }) => {
  return (
    <button className="feedback-button" onClick={onClick} title="Send Feedback">
      <i className="fas fa-comment-alt"></i>
    </button>
  );
};

export default FeedbackButton;